import { type MutableRefObject, useCallback } from 'react';
import type { YMap } from '@yandex/ymaps3-types';
import type { Nullable } from '@direct-frontend/stdlib';

interface UseMapViewportProps {
    ymapRef: MutableRefObject<Nullable<YMap>>;
}

export const useMapViewport = (props: UseMapViewportProps) => {
    const { ymapRef } = props;

    const getMapBounds = useCallback(() => {
        if (ymapRef.current) {
            return ymapRef.current.bounds;
        }

        return null;
    }, [ymapRef]);

    const getMapCenter = useCallback(() => {
        if (ymapRef.current) {
            return ymapRef.current.center;
        }

        return null;
    }, [ymapRef]);

    const getMapZoom = useCallback(() => {
        if (ymapRef.current) {
            return ymapRef.current.zoom;
        }

        return null;
    }, [ymapRef]);

    return {
        getMapBounds,
        getMapCenter,
        getMapZoom,
    };
};
